export default __webpack_public_path__ + "static/tray-draft-11d8ee47a3a9dbc453b886d0af94dac9.svg";